import { Customer } from "@/models/response/customer";
import { Avatar, Checkbox, Group, Paper, Stack, Text } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

type Props = {
  customer: Customer;
  showDetails?: boolean;
  close?: ((customerId: number) => void) | undefined
};

function CustomerItem({ customer, showDetails = true, close }: Props) {
  const navigate = useNavigate();
  const goToDetail = () => {
    if (showDetails) navigate(`/dashboard/customers/details/${customer?.id}`);
  };
  return (
    <Paper p="md" radius="md" onClick={close ? () => close(customer?.id || 0) : goToDetail} >
      <Group justify="space-between">
        <Group justify="space-between">
          <Group>
            {!showDetails && <Checkbox checked readOnly />}
            <Avatar color="blue" radius="xl" size="lg">
              {customer?.firstName?.charAt(0) || ""}
            </Avatar>
            {/* <Avatar color="blue" radius="sm">
              <GenderAvatar gender={customer?.gender} />
            </Avatar> */}
            <Stack gap="0">
              <Text size="md">{customer.phoneNumber}</Text>
              <Text size="xs" style={{ overflowWrap: "anywhere" }}>معرف: {customer.referrer || "—"}</Text>
              {
                <Text size="xs" c="gray">{`${customer?.firstName || ""} ${customer?.lastName || ""
                  }`}</Text>
              }
            </Stack>
          </Group>
        </Group>
        {showDetails && (
          close ?
            <Group gap="2" justify="end">
              <Text size="xs">انتخاب</Text>
              <IconChevronLeft size="10px" />
            </Group> :
            <Group gap="2" justify="end">
              <Text size="xs">جزییات</Text>
              <IconChevronLeft size="10px" />
            </Group>
        )}

        {/* {(customer?.firstName || customer?.lastName) && (
          <Stack spacing="xs">
            {
              <Text size="md">{`${customer?.firstName || ""} ${
                customer?.lastName || ""
              }`}</Text>
            }
            <Group>
              {customer?.birthDate && (
                <Stack spacing="xs">
                  <Text size="xs" color="gray">
                    تاریخ تولد
                  </Text>
                  <Group>
                    <Text>
                      {moment(customer?.birthDate).format("jYYYY/jM/jD")}
                    </Text>
                  </Group>
                </Stack>
              )}
              {customer?.dateOfMarriage && (
                <Stack spacing="xs">
                  <Text size="xs" color="gray">
                    تاریخ ازدواج
                  </Text>
                  <Group>
                    <Text>
                      {moment(customer?.dateOfMarriage).format("jYYYY/jM/jD")}
                    </Text>
                  </Group>
                </Stack>
              )}
            </Group>
          </Stack>
        )} */}
      </Group>
    </Paper>
  );
}

export default CustomerItem;
